import React from 'react';
import { Band } from './Band';
import { roleGroups } from '../../data/site';
export function Roles() {
  return <Band id="roles" eyebrow="Where Lentic works" title="Built for judgement-heavy knowledge work." description="Lentic can be configured around the decisions, evidence and AI workflows of the role being hired for." data-id="element-307" data-mp="2xpjt1hymqqaa">
      <dl className="grid gap-10 md:grid-cols-3" data-id="element-308" data-mp="37kbq8koavb4j">
        {roleGroups.map(group => <div key={group.label} className="border-t border-mist pt-6" data-id="element-309" data-mp="3bm72ulbolaxm">
            <dt className="font-display text-lg font-medium text-ink" data-id="element-310" data-mp="3gm1qmg05tkeg">
              {group.label}
            </dt>
            <dd className="mt-4 flex flex-wrap gap-2" data-id="element-311" data-mp="3leuwj77d6ys4">
              {group.roles.map(role => <span key={role} className="rounded-full bg-white px-3.5 py-1.5 text-[15px] text-graphite" data-id="element-312" data-mp="3qce9m3sbt5ih">
                  {role}
                </span>)}
            </dd>
          </div>)}
      </dl>
    </Band>;
}